import { OptionProps } from "../../constants/types";
import {
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  InputLabel,
} from "@mui/material";
import React from "react";

type MuiDropDownProps = {
  label?: string;
  placeholder: string;
  options: OptionProps[];
  isInvalid?: boolean;
  errorText?: string;
  isRequired?: boolean;
  onChange: (value: string, id: string) => void;
  onBlur?: () => void;
  value: string;
  disabled?: boolean;
};

export const MuiDropDown = ({
  options,
  placeholder,
  errorText,
  isInvalid = false,
  isRequired = false,
  onChange,
  onBlur,
  value,
  disabled,
  label,
}: MuiDropDownProps) => {
  // Create label with red asterisk if required
  const renderLabel = isRequired ? (
    <span>
      {label}
      <span style={{ color: "red" }}> *</span>
    </span>
  ) : !!label ? (
    label
  ) : (
    placeholder
  );

  return (
    <FormControl
      fullWidth
      error={isInvalid}
      // required={isRequired}
      disabled={disabled}
      variant="outlined"
    >
      <InputLabel id="mui-select-label">{renderLabel}</InputLabel>
      <Select
        labelId="mui-select-label"
        id="mui-select"
        value={value}
        onChange={(e) => {
          const selectedOption = options.find(
            (opt) => opt.value === e.target.value
          );
          onChange(e.target.value, selectedOption?.id ?? "");
        }}
        onBlur={onBlur}
        label={label ?? placeholder}
      >
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {isInvalid && <FormHelperText>{errorText}</FormHelperText>}
    </FormControl>
  );
};
